<template>
  <div>
    <div class="row">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">IndexPage</el-breadcrumb-item>
        <el-breadcrumb-item>Base</el-breadcrumb-item>
        <el-breadcrumb-item>Relation</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="row filter">

      <div class="filter-item clear">
      <div class="item-head ">
        <span>Development:</span>
      </div>
      <div class="item-content">
        <el-input v-model="filter.developmentName" placeholder=""></el-input>
      </div>
    </div>

      <div class="filter-item clear">
        <div class="item-head ">
          <span>Tower:</span>
        </div>
        <div class="item-content">
          <el-input v-model="filter.towerName" placeholder=""></el-input>
        </div>
      </div>

      <div class="filter-item clear">
        <div class="item-head ">
          <span>Floor:</span>
        </div>
        <div class="item-content">
          <el-input v-model="filter.floorName" placeholder=""></el-input>
        </div>
      </div>

      <div class="filter-item clear">
        <div class="item-head ">
          <span>Flat:</span>
        </div>
        <div class="item-content">
          <el-input v-model="filter.flatName" placeholder=""></el-input>
        </div>
      </div>

      <div class="filter-item clear">
        <div class="item-head ">
          <span>Status:</span>
        </div>
        <div class="item-content">
          <el-radio-group v-model="filter.status" style="margin-top: 8px;">
            <el-radio label="">所有状态</el-radio>
            <el-radio label="1">已完成</el-radio>
            <el-radio label="2">未完成</el-radio>
          </el-radio-group>
        </div>
      </div>



    </div>

    <div class="row">
      <el-button type="primary" @click.native="process">Query</el-button>
      <el-button type="primary" @click.native="add">New</el-button>
      <el-button type="primary" @click.native="update">设置下级</el-button>
      <el-button type="primary" @click.native="del">删除</el-button>
    </div>

    <div class="row">
      <template>
        <el-table
          :data.sync="records"
          stripe
          border
          style="width: 100%"
          @selection-change="selectionChange"
          @sort-change="sortChange"
          ref="tab1"
        >
          <el-table-column
            type="selection"
            min-width="30px">
          </el-table-column>
          <el-table-column
            prop="id"
            label="ID"
            min-width="50px">
          </el-table-column>



          <el-table-column
            sortable="custom"
            prop="developmentName"
            label="DevelopmentName"
            min-width="100px">
          </el-table-column>


          <el-table-column
            sortable="custom"
            prop="towerName"
            label="TowerName"
            min-width="100px">
          </el-table-column>


          <el-table-column
            sortable="custom"
            prop="floorName"
            label="FloorName"
            min-width="100px">
          </el-table-column>

          <el-table-column
            sortable="custom"
            prop="flatName"
            label="FLAT"
            min-width="100px">
          </el-table-column>

          <el-table-column
            sortable="custom"
            prop="createAt"
            label="CREATE"
            min-width="100px">
          </el-table-column>
        </el-table>
      </template>
    </div>

    <div class="row">
      <el-pagination
        @size-change="process"
        @current-change="process"
        :current-page.sync="page.currentPage"
        :page-sizes="[10, 50, 100, 1000]"
        :page-size.sync="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>



    <!-- new form-->
    <div class="row">
      <el-dialog :title="form.title" :visible.sync="form.dialogFormVisible">

        <div class="row">
          <template>
            <el-table
              :data.sync="form.records"
              stripe
              border
              style="width: 100%"
              @selection-change="formSelectionChange"
            >
              <el-table-column
                type="selection"
                min-width="30px">
              </el-table-column>

              <el-table-column
                :prop="form.idProp"
                :label="form.idLabel"
                min-width="100px">
              </el-table-column>

              <el-table-column
                :prop="form.nameProp"
                :label="form.nameLabel"
                min-width="100px">
              </el-table-column>

              <el-table-column
                prop="createAt"
                label="CREATE"
                min-width="100px">
              </el-table-column>
            </el-table>
          </template>
        </div>

        <div class="row">
          <el-pagination
            @size-change="processForm"
            @current-change="processForm"
            :current-page.sync="form.page.currentPage"
            :page-sizes="[10, 20, 50]"
            :page-size.sync="form.page.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="form.total">
          </el-pagination>
        </div>





        <div slot="footer" class="dialog-footer">
          <el-button @click="form.dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="submit">确 定</el-button>
        </div>
      </el-dialog>
    </div>


  </div>
</template>

<script>
  import * as constants from "../../utils/constants";

  export default {
    name: "Flat",
    data: function () {
      return {
        boolTrue:true,
        filter: {
          status:"",
          orderField:""
        },
        records: [],
        total: 0,
        page: {
          pageSize: 10,
          currentPage: 1
        },
        sections:[],
        form: {
          processUrl:'',
          title:'',
          idProp:'',
          idLabel:'',
          nameProp:'',
          nameLabel:'',
          type:'selection',
          total:0,
          records:[],
          page:{
            pageSize: 10,
            currentPage: 1,
          },
          dialogFormVisible: false,
          url:'',
          sections:[]
        }
      };
    },
    created: function () {
      console.log(sessionStorage.getItem(constants.TOKEN))
      this.process();
    },
    methods: {
      process: function () {
        this.$http.post("/dRelation/list", {
          filter: this.filter,
          pageSize: this.page.pageSize,
          currentPage: this.page.currentPage
        }).then(response => {
          this.records = response.data.data.data;
          this.total = response.data.data.total;
        });
      },
      //处理表单数据
      processForm:function(){
        this.$http.post(this.form.processUrl,{
         currentPage:this.form.page.currentPage,
         pageSize:this.form.page.pageSize
        }).then(response=>{
          if(response.data.code === "1"){
            this.form.records = response.data.data.data;
            this.form.total = response.data.data.total;
          }
        });
      },
      //选项更改时
      selectionChange:function (sections) {
        this.sections = sections;
      },
      formSelectionChange:function (sections) {
        this.form.sections = sections;
      },
      submit: function () {
        //新增记录
        if(this.sections.length === 0){
          //没有选择数据
          if(this.form.sections.length ===0){
            this.form.dialogFormVisible =false;
            return ;
          }
          let developmentIds = "";
          for(let index=0;index<this.form.sections.length;index++){
            developmentIds +=this.form.sections[index].developmentId+",";
          }
          this.$http.post(this.form.url,{
            developmentIds: developmentIds
          }).then(response=>{
            if(response.data.code === "1"){
              this.form.dialogFormVisible = false;
              this.$message.success("操作成功");
              this.process();
            }
          });
        }else{
          //设置下一级
          if(this.form.sections.length === 0){
            this.form.dialogFormVisible =false;
            return;
          }
          //下级id
          let ids = "";
          console.log(this.form.sections[0].floorId || this.form.sections[0].towerId || this.form.sections[0].flatId)
          for(let index=0;index<this.form.sections.length;index++){
            console.log(this.form.sections[index].towerId);
            ids = ids + (this.form.sections[index].floorId || this.form.sections[index].towerId || this.form.sections[index].flatId);
            ids = ids + ",";
          }
          let relationId = "";
          for(let relation of this.sections)
            relationId += relation.id + ",";
          this.$http.post(this.form.url,{
            relationId:relationId,
            ids:ids
          }).then(response=>{
            if(response.data.code === "1"){
              this.form.dialogFormVisible =false;
              this.$message.success("操作成功");
              this.process();
            }
          })
        }
      },
      del:function () {
        if(this.sections.length === 0){
          this.$message.error("没有选择数据");
          return ;
        }

        var ids = "";
        for(var index=0;index<this.sections.length;index++){
          ids += this.sections[index].id + ",";
        }

        this.$confirm('确定删除这些记录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(()=>{
          this.$http.post("/dRelation/delete",{
            ids: ids,
          }).then(response=>{
            if(response.data.code === "1"){
              this.$message.success("删除成功");
              this.process();
            }
          })
        });

      },
      //新增
      add:function () {
        //清空数据选择
        this.$refs.tab1.clearSelection();
        this.form.title = "选择Development";
        this.form.processUrl = "/development/list";
        this.form.url = "/dRelation/add";
        this.form.idProp = "developmentId";
        this.form.idLabel = "DevelopmentId";
        this.form.nameProp = "developmentName";
        this.form.nameLabel = "DevelopmentName";
        this.processForm();
        this.form.dialogFormVisible =true;
      },
      //设置下级
      update:function () {
         if(this.sections.length === 0){
           this.$message.error("未选择数据");
            return;
         }
         //var developmentId = this.sections[0].developmentId;
         let towerId = this.sections[0].towerId;
         let floorId = this.sections[0].floorId;
         let flatId = this.sections[0].flatId;
        if(towerId && floorId && flatId){
          this.$message.error("只能设置未完成的数据");
          return;
        }
        //判定状态
        if(!this.validateNextLevel(this.sections)){
          this.$message.error("层级结构不一致");
          return;
        }
        this.form.url="/dRelation/update";
        if(!towerId){
          this.form.title = "选择Tower";
          this.form.processUrl = "/tower/list";
          this.form.idProp = "towerId";
          this.form.idLabel = "TowerId";
          this.form.nameProp = "towerName";
          this.form.nameLabel = "TowerName";
        }else if(!floorId){
          this.form.title = "选择Floor";
          this.form.processUrl = "/floor/list";
          this.form.idProp = "floorId";
          this.form.idLabel = "FloorId";
          this.form.nameProp = "floorName";
          this.form.nameLabel = "FloorName";
        }else{
          this.form.title = "选择Flat";
          this.form.processUrl = "/flat/list";
          this.form.idProp = "flatId";
          this.form.idLabel = "FlatId";
          this.form.nameProp = "flatName";
          this.form.nameLabel = "FlatName";
        }
        this.processForm();
        this.form.dialogFormVisible = true;
      },
      //判定集合是否符合要求
      validateNextLevel(selections) {
        if (selections.length <= 1)
          return true;
        let validateFlag = 0;
        for(let selection of selections){
          if(!validateFlag){
            validateFlag = this.validateFlag(selection);
            continue;
          }
          //判定是否合理
          if(this.validateFlag(selection) !== validateFlag)
            return false;
        }
        return true;
      },
      //判定状态
      validateFlag(selection){
        let flag = 0;
        if(selection == null || typeof(selection) === "undefined")
          return flag;
        if(selection.developmentId)
          flag |= 8;
        if(selection.towerId)
          flag |= 4;
        if(selection.floorId)
          flag |= 2;
        if(selection.flatId)
          flag |= 1;
        return flag;
      },
      sortChange(column){
        if(column == null){
          this.filter.orderField = "";
          return ;
        }
        this.filter.orderField =  column.order.toLowerCase() === "ascending" ? column.prop + " asc" : column.prop + " desc";
        this.process();
      }
    }
  }
</script>

<style scoped>

  .filter {
    border: 1px solid #DCDFE6;
  }

  .filter > .filter-item {
    border-bottom: 1px dashed #DCDFE6;
    position: relative;
    display: block;
    padding: 5px 0 5px 0;
  }

  .filter > .filter-item:last-of-type {
    border-bottom: none;
  }

  .filter > .filter-item > .item-head {
    display: inline-block;
    width: 150px;
    float: left;
    line-height: 32px;
    padding-left: 10px;
  }

  .filter > .filter-item > .item-content {
    display: block;
    float: left;
    margin-left: 10px;
  }

  .clear {
    display: block;
    overflow: hidden;
  }


</style>



// WEBPACK FOOTER //
// src/components/base/Relation.vue